import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  subscriptions: [],
  freeSubscription: {},
  paidSubscription: {},

  activationKey: '',
  price: null,

  applications: null,

  renewStatus: null,
  toggleAutopayStatus: null,

  accounts: [],
  summary: {},
  key: '',
  createStatus: '',
  deleteStatus: '',

  account: {},
  updateStatus: '',
  reportsSetup: {},
  updateReportsSetupStatus: '',
  alertsSetup: {},
  updateAlertsSetupStatus: '',

  telegram: '',
  unsubscribeTgStatus: '',
}

export const monitoringSlice = createSlice({
  name: 'monitoring',
  initialState,
  reducers: {
    setMonitoringSubscriptions: (state, action) => { state.subscriptions = action.payload },
    setMonitoringFreeSubscription: (state, action) => { state.freeSubscription = action.payload },
    setMonitoringPaidSubscription: (state, action) => { state.paidSubscription = action.payload },

    setMonitoringActivationKey: (state, action) => { state.activationKey = action.payload },
    setMonitoringPrice: (state, action) => { state.price = action.payload },

    setMonitoringApplications: (state, action) => { state.applications = action.payload },

    setMonitoringRenewStatus: (state, action) => { state.renewStatus = action.payload },
    setMonitoringToggleAutopayStatus: (state, action) => { state.toggleAutopayStatus = action.payload },

    setMonitoringAccounts: (state, action) => { state.accounts = action.payload },
    setMonitoringSummary: (state, action) => { state.summary = action.payload },
    setMonitoringKey: (state, action) => { state.key = action.payload },
    setMonitoringCreateStatus: (state, action) => { state.createStatus = action.payload },
    setMonitoringDeleteStatus: (state, action) => { state.deleteStatus = action.payload },

    setMonitoringAccount: (state, action) => { state.account = action.payload },
    setMonitoringUpdateStatus: (state, action) => { state.updateStatus = action.payload },
    setMonitoringReportsSetup: (state, action) => { state.reportsSetup = action.payload },
    setMonitoringUpdateReportsSetupStatus: (state, action) => { state.updateReportsSetupStatus = action.payload },
    setMonitoringAlertsSetup: (state, action) => { state.alertsSetup = action.payload },
    setMonitoringUpdateAlertsSetupStatus: (state, action) => { state.updateAlertsSetupStatus = action.payload },

    setMonitoringTg: (state, action) => { state.telegram = action.payload },
    setMonitoringUnsubscribeTgStatus: (state, action) => { state.unsubscribeTgStatus = action.payload },

    resetMonitoring: () => initialState,
  },
})

export const {
  setMonitoringSubscriptions,
  setMonitoringFreeSubscription,
  setMonitoringPaidSubscription,

  setMonitoringActivationKey,
  setMonitoringPrice,

  setMonitoringApplications,

  setMonitoringRenewStatus,
  setMonitoringToggleAutopayStatus,

  setMonitoringAccounts,
  setMonitoringSummary,
  setMonitoringKey,
  setMonitoringCreateStatus,
  setMonitoringDeleteStatus,

  setMonitoringAccount,
  setMonitoringUpdateStatus,
  setMonitoringReportsSetup,
  setMonitoringUpdateReportsSetupStatus,
  setMonitoringAlertsSetup,
  setMonitoringUpdateAlertsSetupStatus,

  setMonitoringTg,
  setMonitoringUnsubscribeTgStatus,

  resetMonitoring,
} = monitoringSlice.actions

export default monitoringSlice.reducer